class SearchBar {
    constructor() {
        this.searchBar = document.querySelector(".wp-block-search__inside-wrapper > .wp-block-search__input");
        this.searchButton = document.querySelector(".wp-block-search__inside-wrapper > .wp-block-search__button");
        this.searchIcon = document.querySelector(".wp-block-search__button > .search-icon");
        this.headerRightColumn = document.querySelector(".header__right-column");
        this.events();
    }

    events() {
        if (this.searchBar) {
            // Remove required to prevent console errors
            this.searchBar.required = false;
            
            // Disable search button
            this.searchButton.disabled = true;
            this.searchIcon.addEventListener("click", () => {
                // Add the "show" class to the search bar
                this.searchBar.classList.toggle("show");
                this.headerRightColumn.classList.toggle("search-bar-open");
                // Put the cursor in the search bar
                this.searchBar.focus();
                // Wait one second and enable the search button again
                setTimeout(() => {
                    this.searchButton.disabled = false;
                }
                , 1000);

                // If the user clicks away from the search bar, remove the "show" class
                this.searchBar.addEventListener("blur", () => {
                    this.searchBar.classList.remove("show");
                    this.headerRightColumn.classList.remove("search-bar-open");
                    this.searchButton.disabled = true;
                }
                );
            });
        }

    }
}

export default SearchBar;